import React from 'react'
import { Typography, Button, Row, Col } from 'antd'
import { Slide, Zoom } from 'react-awesome-reveal'
import { isMobile } from 'react-device-detect'
import './HeroSection.css'
import { translate } from '../../../cls/TranslationContext'
import { useNavigate } from 'react-router-dom'
const { Title, Paragraph } = Typography

const HeroSection = () => {
	const navigate = useNavigate()
	return (
		<div
			className="hero-container"
			style={isMobile ? { minHeight: 'unset' } : {}}
		>
			<Row
				align="middle"
				justify="center"
				className="hero-content"
				gutter={[16, 16]}
			>
				<Col xs={24} md={12} className="hero-text">
					<Slide triggerOnce direction="left">
						<Title className="hero-title">
							{translate('home.heroTitle')}
						</Title>
						<Paragraph className="hero-subtitle">
							{translate('home.heroSubtitle')}
						</Paragraph>
						<Button
							onClick={() => {
								navigate('/signup')
							}}
							type="primary"
							size="large"
							className="hero-button"
						>
							{translate('home.heroBtn')}
						</Button>
					</Slide>
				</Col>
				{!isMobile && (
					<Col xs={24} md={12} className="hero-image">
						<Zoom triggerOnce delay={300}>
							<img
								src="/images/hero-simple.png"
								alt="Time is back in your hands"
							/>
						</Zoom>
					</Col>
				)}
			</Row>
		</div>
	)
}

export default HeroSection
